import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { Tally1 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { changeShoppingFlag } from '../../store';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

function Coupons_Footer() {
    const { t } = useTranslation();
    let navigate = useNavigate();

    return (
        <div style={{ width: "100%", padding: "15px", background: "rgb(245, 245, 245)" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "500", color: "#8f8f8f", marginBottom: "5px" }}>
                <div style={{ padding: "10px 12px 10px 0", cursor: "pointer" }}
                    onClick={() => { navigate('/terms') }}>
                    {t('shopping_45')}
                </div>
                <Tally1 size={14} style={{ color: "#d3d3d3" }} />
                <div style={{ padding: "10px 0", cursor: "pointer" }}
                    onClick={() => { navigate('/privacyPolicy') }}>
                    {t('shopping_46')}
                </div>
            </div>
            <div style={{ fontSize: "11px", fontWeight: "500", color: "#b5b5b5", marginBottom: "30px", textAlign: "left" }}>
                {t('shopping_47')}
            </div>
            <div style={{ marginBottom: "20px" }}>
                <RowItem label={"서울여의도청년회의소"} value={"회장 신승일"} />
                <RowItem label={"주소"} value={"서울시 영등포구 여의도동 은행로 58, 삼도오피스텔 1207호"} />
                {/* <RowItem label={"사업자등록번호"} value={"883-81-01854"} /> */}
                {/* <RowItem label={"통신판매업신고번호"} value={"제2020-서울강남-03097호"} /> */}
                <RowItem label={"호스팅사업자"} value={"서울여의도쳥년회의소"} />
            </div>
        </div>
    );
}

function RowItem({ label, value }) {
    return (
        <div
            style={{
                display: 'flex',
                fontSize: '11px',
                padding: '2px 0',
                // alignItems: 'center',
                fontWeight: "500",
                color: "#b5b5b5",
                textAlign: "left"
            }}
        >
            <div style={{ width: "120px" }}>{label}</div>
            <div style={{ width: "calc(100% - 120px)" }}>{value}</div>
        </div>
    );
}


export default Coupons_Footer;